import { owcTheme } from '@one/design-tokens/js/regular/navify/light';
import { OwcComponentHeader } from '@one/react';
import styled from 'styled-components';

// Two 1px card borders, 16 + 8 header wrapper padding and the 8 gap: any wider shifts the workflow right
const headerWidthOffset = `(2px + ${owcTheme['one-spacing-base-4']} + 2 * ${owcTheme['one-spacing-base-2']})`;
const titlePrefixWidth = `(${owcTheme['one-spacing-base-4']} + ${owcTheme['one-spacing-base-6']} + ${owcTheme['one-spacing-base-2']})`;

export const WorkflowHeaderLayout = styled(OwcComponentHeader)`
  padding-left: 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: calc(100vw - ${headerWidthOffset});

  & > div > div.owc-component-header__prefix-container__title {
    max-width: calc(100vw - ${headerWidthOffset} - ${titlePrefixWidth});
  }
`;

export const WorkflowHeaderTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 1 auto;
  min-width: 0;

  owc-typography {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
